import React from "react";
import { App } from "antd";
import { useNavigate, Route, Routes, Navigate } from "react-router-dom";
import {
  MitigatorHomeScreen,
  RegisterTrackerScreen,
  RegisterHomeScreen,
  ThreatsTrackerScreen,
  VulnerabilitiesTrackerScreen,
  AssetsTrackerScreen,
  RatingsTrackerScreen,
  ReferencesTrackerScreen,
  StatsScreen,
  RiskDetailsScreen,
} from "../screens";
import { NMHomeScreen, NMLoginScreen, NMPageNotFoundPage } from "@neumetric/blueprint-lib/pages";

const LOGIN_ENDPOINT = process.env.REACT_APP_LOGIN_ENDPOINT;
const ENVIRNOMENT_ID = process.env.REACT_APP_ENVIRNOMENT_ID;
const ENVIRNOMENT_TITLE = process.env.REACT_APP_ENVIRNOMENT_TITLE;
const ModuleID = "mitigator";
const Environment = { id: ENVIRNOMENT_ID, title: ENVIRNOMENT_TITLE };

const NotFoundRedirect = () => <Navigate replace to="/page-not-found" />;

const ListRouter = () => {
  return (
    <Routes>
      <Route path="T" element={<ThreatsTrackerScreen />} />
      <Route path="V" element={<VulnerabilitiesTrackerScreen />} />
      <Route path="A" element={<AssetsTrackerScreen />} />
      <Route path="R" element={<RatingsTrackerScreen />} />
      <Route path="Ref" element={<ReferencesTrackerScreen />} />
      <Route path="/" element={<Navigate replace to="T" />} />
      <Route path="" element={<Navigate replace to="/" />} />
      <Route path="/*" element={<NotFoundRedirect />} />
    </Routes>
  );
};

const MitigatorRouter = () => (
  <MitigatorHomeScreen>
    <Routes>
      <Route index element={<Navigate replace to="R" />} />
      <Route element={<RegisterHomeScreen />}>
        <Route path="R" element={<RegisterTrackerScreen key="register" />} />
        <Route path="S" element={<StatsScreen />} />
        <Route path="A" element={<RegisterTrackerScreen key="archive" isArchiveTab={true} />} />
        <Route path="L/*" element={<ListRouter />} />
      </Route>
      <Route path="R/:riskId" element={<RiskDetailsScreen key="register" />} />
      <Route path="A/:riskId" element={<RiskDetailsScreen key="archive" />} />
      <Route path="*" element={<NotFoundRedirect />} />
    </Routes>
  </MitigatorHomeScreen>
);

const MainRouter = () => {
  const context = App.useApp();
  return (
    <NMHomeScreen appContext={context} environment={Environment} loginEndpoint={LOGIN_ENDPOINT} moduleId={ModuleID}>
      <Routes>
        <Route index element={<Navigate replace to="/M" />} />
        <Route path="M/*" element={<MitigatorRouter />} />
        <Route path="*" element={<NotFoundRedirect />} />
      </Routes>
    </NMHomeScreen>
  );
};

const LogInWrapper = () => {
  const navigate = useNavigate();
  return <NMLoginScreen onNavigate={(path) => navigate(path)} moduleId={ModuleID} environment={Environment} />;
};

function AppRouter() {
  const navigate = useNavigate();
  return (
    <Routes>
      <Route path="/login" element={<LogInWrapper />} />
      <Route
        path="/page-not-found"
        element={<NMPageNotFoundPage loginEndpoint={LOGIN_ENDPOINT} onNavigate={(path) => navigate(path)} />}
      />
      <Route path="/*" element={<MainRouter />} />
    </Routes>
  );
}

export default AppRouter;
